
























































import { Component, Vue } from 'vue-property-decorator';
import { ModalConstants, BusConstants } from '@/core/constants';
import { AdminApi } from '@/services/api/api.admin';
import { User } from '@/models/user/user.model';

import bus from '@/core/bus';
import { RealmsModule } from '@/store/modules/realms/realms.store';

import EditUserProfile from './EditUserProfile.vue';
import EditIngameAccount from './EditIngameAccount.vue';
import EditUserRealms from './EditUserRealms.vue';
import EditUserRoles from './EditUserRoles.vue';
import EditUserPermissions from './EditUserPermissions.vue';
import EditUserGameRanks from './EditUserGameRanks.vue';
import EditUserAllowedCoreFiles from './EditUserAllowedCoreFiles.vue';
import { UserDetailsViewModel, Permission, PermissionCategory, UserDetailsRequest } from '@/types/apiServerContract';

@Component({
    components: {
        EditUserProfile,
        EditIngameAccount,
        EditUserRealms,
        EditUserRoles,
        EditUserPermissions,
        EditUserGameRanks,
        EditUserAllowedCoreFiles
    }
})
export default class UserModerationOverlay extends Vue {
	id: string = ModalConstants.UserModeration;

	user: User | null = null;
	userData: UserDetailsViewModel | null = null;
	permissions: Permission[] = [];
	permissionCategories: PermissionCategory[] = [];

	loading: boolean = false;

	get Title(): string {
	    return this.loading ? 'Loading...' : this.user && this.userData ? this.user.userName : 'Unknown Error';
	}

	get ActiveRealmId() {
	    return RealmsModule.activeRealmId;
	}

	async GetUserDetails() {
	    if (!this.user) return;

	    this.userData = null;

	    const request: UserDetailsRequest = {
	        userId: this.user.id
	    };
	    const data: UserDetailsViewModel = await AdminApi.GetUserDetails(request);
	    this.userData = data;
	    this.user.lastLogin = data.lastLogin;
	}

	async GetPermissions() {
	    const result = await AdminApi.GetPermissions();
	    this.permissions = result.permissions;
	    this.permissionCategories = result.categories;
	}

	async Init() {
	    this.loading = true;
	    this.userData = null;

	    try {
	        await this.GetUserDetails();
	        await this.GetPermissions();
	    } finally {
	        this.loading = false;
	    }
	}

	created() {
	    bus.on(BusConstants.SelectedUserChanged, (user: User) => (this.user = user));
	}

	destroyed() {
	    this.user = null;
	    this.userData = null;
	    bus.off(BusConstants.SelectedUserChanged, (user: User) => (this.user = user));
	}
}
